import React from 'react';
import PropTypes from 'prop-types';

import SignUpForm from 'components/auth/SignUpForm';
import Footer from 'pages/Login/footer';
import { OnTruckLogo } from 'refactored/ui/icons';

const SignUp = ({ className, userDataHash, t }) => (
  <div className={className}>
    <section className="main" role="main">
      <OnTruckLogo />
      <SignUpForm userDataHash={userDataHash} />
    </section>
    <Footer t={t} />
  </div>
);

SignUp.propTypes = {
  className: PropTypes.string,
  userDataHash: PropTypes.string,
  t: PropTypes.func,
};

SignUp.defaultProps = {
  className: '',
  userDataHash: '',
  t: (t) => t,
};

export default SignUp;
